import {
  ClockStationService,
  ClockStation_SetAstronomicRelayCoordinatesModel,
  ClockStation_SetAstronomicRelaySourceModel,
  GetClockStationRelayInfo_GetClockStationRelayInfoResponse,
  GetClockStationRelayStatus_GetClockStationRelayStatusResponse,
  ClockStation_SetRelayModeModel,
  ClockStation_SetRelayTimeScheduleModel,
  CoordinatesSource,
  UpdateClockStationRelayDescriptionModel,
} from "../api";
import {
  Coordinates,
  DuskDawnTimeResponse,
  RelayTime,
  RelayTimeUpdatePayload,
} from "../components/menu/RelaySettings/RelaySettings.model";
import {
  mapTimeValueToTimeString,
  mapRelayCoordinatesResponse,
  mapRelayTimeResponse,
} from "../shared/Helpers.utils";

export const RelaySettingsApi = {

  // Получение режима реле
  getRelayStatus: async (id: string): Promise<GetClockStationRelayStatus_GetClockStationRelayStatusResponse> => {
    return ClockStationService.getApiClockStationRelayStatus(id);
  },

  // Получение описания реле
  getRelayDescription: async (id: string): Promise<GetClockStationRelayInfo_GetClockStationRelayInfoResponse> => {
    return ClockStationService.getApiClockStationRelay(id);
  },

  // Обновление описания реле
  updateRelayDescription: async (id: string, payload: UpdateClockStationRelayDescriptionModel): Promise<boolean> => {
    await ClockStationService.putApiClockStationRelayDescription(id, payload);
    return true;
  },

  // Обновление описания реле
  updateRelayModes: async (id: string, payload: ClockStation_SetRelayModeModel): Promise<boolean> => {
    await ClockStationService.postApiClockStationRelayMode(id, payload);
    return true;
  },

  // Получение реле времени
  getRelayTime: async (id: string): Promise<RelayTime> => {
    const response = await ClockStationService.getApiClockStationRelayScheduler(id);
    return mapRelayTimeResponse(response as Record<string, unknown>);
  },

  // Обновление реле времени
  updateRelayTime: async (id: string, payload: RelayTimeUpdatePayload): Promise<boolean> => {
    await ClockStationService.postApiClockStationRelayScheduler(
      id,
      payload as unknown as ClockStation_SetRelayTimeScheduleModel
    );
    return true;
  },

  // Получение восход / закат
  getDuskDawnTime: async (id: string): Promise<DuskDawnTimeResponse> => {
    const response = await ClockStationService.getApiClockStationRelayDuskDawn(id);
    const runtimeResponse = response as unknown as DuskDawnTimeResponse & {
      dawnTime?: unknown;
      duskTime?: unknown;
    };

    if (typeof runtimeResponse.onTime === "string" || typeof runtimeResponse.offTime === "string") {
      return {
        onTime: runtimeResponse.onTime ?? "",
        offTime: runtimeResponse.offTime ?? "",
      };
    }

    return {
      onTime: mapTimeValueToTimeString(runtimeResponse.duskTime),
      offTime: mapTimeValueToTimeString(runtimeResponse.dawnTime),
    };
  },

  // Получение gps координат
  getGpsCoordinates: async (id: string): Promise<Coordinates> => {
    const response = await ClockStationService.getApiClockStationGpsCoordinates(id);
    return mapRelayCoordinatesResponse(response as Record<string, unknown>);
  },

  // Ручной ввод координат
  updateCoordinates : async (id: string, coordinates: Coordinates): Promise<boolean> => {
    const requestBody: ClockStation_SetAstronomicRelayCoordinatesModel = {
      latitudeDirection: coordinates.latitudeDirection,
      latitude: coordinates.latitude,
      longitudeDirection: coordinates.longitudeDirection,
      longitude: coordinates.longitude,
    };

    await ClockStationService.postApiClockStationGpsCoordinates(id, requestBody);
    return true;
  },

  // Обновление источника координат
  updateCoordinatesSource : async (id: string, coordinateSource: CoordinatesSource): Promise<boolean> => {
    const requestBody: ClockStation_SetAstronomicRelaySourceModel = {
      coordinateSource,
    };

    await ClockStationService.postApiClockStationGpsCoordinatesSource(id, requestBody);
    return true;
  },
}
